import moment from "moment/moment";

export const convertToMoment = (date?: string, time?: string) => {
  let dt = date || moment().format('YYYY-MM-DD');
  if (time) {
    dt += ` ${time}`;
  }
  return moment(dt);
}

export const dddd = (date: string) => {
  moment.locale('tr');

  return moment(date).format('dddd');
};
export const MMMMDo = (date: string) => {
  moment.locale('tr');

  return moment(date).format('Do MMMM');
};
export const YYYYMMDD = (date: string) => {
  moment.locale('tr');

  return moment(date).format('DD.MM.YYYY');;
};

export const isEqual = (a: any, b: any): boolean => {
  if (a === b) return true;

  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
  if (a.prototype !== b.prototype) return false;

  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  return keys.every(k => isEqual(a[k], b[k]));
}

export const cloneObject = (obj: any): any => {
  return JSON.parse(JSON.stringify(obj));
}

export const pick = (obj: any, keys: string[]): any => {
  return keys.reduce((acc, key) => {
    if (obj && obj.hasOwnProperty(key)) {
      (acc as any)[key] = obj[key];
    }
    return acc;
  }, {});
}

export const omit = (obj: any, keys: string[]): any => {
  return Object.keys(obj)
    .filter(key => keys.indexOf(key) === -1)
    .reduce((acc, key) => {
      (acc as any)[key] = obj[key];
      return acc;
    }, {});
}


export const convertBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })
}
export const rotateImage = (srcBase64: any, degrees: any, callback: any) => {

  const canvas = document.createElement('canvas');
  const ctx: any = canvas.getContext('2d');
  const image = new Image();

  image.onload = function () {
    canvas.width = degrees % 180 === 0 ? image.width : image.height;
    canvas.height = degrees % 180 === 0 ? image.height : image.width;

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(degrees * Math.PI / 180);
    ctx.drawImage(image, image.width / -2, image.height / -2);

    callback(canvas.toDataURL());
  };

  image.src = srcBase64;

}
export const dataUrlToFile = (dataurl: any, filename: any) => {

  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const downloadUrl = (url: string, filename?: string): void => {
  if (typeof window === 'undefined' || !url) return;

  const link = document.createElement('a');
  link.href = url;

  if (filename) {
    link.download = filename;
  }

  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  if (typeof window === 'undefined' || !blob) return;

  const url = window.URL.createObjectURL(blob);
  downloadUrl(url, filename);
  window.URL.revokeObjectURL(url);
};

export const reformatPhoneNumberTR = (phoneNumberString: string | number) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    return '0 ' + '(' + match[1] + ') ' + match[2] + ' ' + match[3] + ' ' + match[4]; // Format: 0 (555) 555 55 55
  }
  return '';
};

export const getApiErrorMessage = (error: any, fallback = 'İşleminizi bilinmeyen bir hatadan ötürü tamamlayamadık.') =>
  error?.response?.data?.detail || error?.response?.data?.message || error?.message || fallback;